import React from 'react'
import classNames from 'classnames'

import NoteIcon from 'components/Notes/Icon'
import Text from 'components/base/Text'

const EXTRANEOUS_PADDING = 8

function Separator() {
  return <div className="width-full border-bottom-small border-shade-45" />
}

export const NotesDirectoryLayoutWrapper = ({
  title = 'Directory',
  hasTwoColumns = false,
  hasMore = false,
  onClickMore,
  itemData,
  ItemComponent = NotesDirectoryLayoutItem,
}) => {
  return (
    <div className="margin-top-small margin-bottom-medium line-height-larger">
      <Text.Callout className="shade-20 padding-vertical-small">
        {title}
      </Text.Callout>
      <Separator />
      <div
        style={{
          marginLeft: -EXTRANEOUS_PADDING,
          marginRight: -EXTRANEOUS_PADDING,
        }}
        className={classNames('flexbox', {
          'flexbox-wrap': hasTwoColumns,
          'flexbox-column': !hasTwoColumns,
        })}
      >
        {itemData.map(note => (
          <ItemComponent
            key={note.id}
            note={note}
            hasTwoColumns={hasTwoColumns}
          />
        ))}
      </div>
      {hasMore && (
        <React.Fragment>
          <div
            style={{
              marginLeft: -EXTRANEOUS_PADDING,
              marginRight: -EXTRANEOUS_PADDING,
              paddingLeft: EXTRANEOUS_PADDING,
              paddingRight: EXTRANEOUS_PADDING,
            }}
            className={classNames(
              'pointer',
              'transition',
              'background-shade-50-on-hover background-shade-45-on-active radius-normal',
              'padding-vertical-normal',
              'shade-20 font-weight-medium font-size-large line-height-larger'
            )}
            onClick={onClickMore}
          >
            Show more
          </div>
          <Separator />
        </React.Fragment>
      )}
    </div>
  )
}

export const NotesDirectoryLayoutItem = React.memo(function({
  note,
  onClick,
  hasTwoColumns,
  renderTitle = ({ note }) => note.title || 'Untitled',
  renderExtra = ({ note }) => null,
}) {
  return (
    <div
      onClick={onClick}
      style={{
        flex: hasTwoColumns ? '50%' : '100%',
        maxWidth: hasTwoColumns ? '50%' : '100%',
        paddingLeft: EXTRANEOUS_PADDING,
        paddingRight: EXTRANEOUS_PADDING,
      }}
      className="flexbox flexbox-column"
    >
      <div
        style={{
          paddingLeft: EXTRANEOUS_PADDING,
          paddingRight: EXTRANEOUS_PADDING,
          marginLeft: -EXTRANEOUS_PADDING,
          marginRight: -EXTRANEOUS_PADDING,
        }}
        className={classNames(
          'pointer',
          'flexbox flexbox-align-center',
          'padding-vertical-normal',
          'font-size-large font-weight-medium line-height-large',
          'transition background-shade-45-on-active background-shade-50-on-hover radius-normal'
        )}
      >
        <NoteIcon
          className="flexbox flexbox-centered margin-right-small shade-20"
          iconShape={note.iconShape}
          iconColor={note.iconColor}
        />
        <div className="flexbox-grow shade-05 ellipsis font-weight-medium line-height-larger">
          {renderTitle({ note })}
        </div>
        {!hasTwoColumns && (
          <div className="line-height-larger shade-20">
            {renderExtra({ note })}
          </div>
        )}
      </div>
      <Separator />
    </div>
  )
})
